import { useEffect, useState, useCallback } from "react";
import "./EmployeeManagement.css";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Link, useNavigate } from "react-router-dom";
import { AgGridReact } from "ag-grid-react";
import { FaDownload } from "react-icons/fa6";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import ExcelReader from "../../components/xlsx/Index";
import { ToastContainer, toast } from "react-toastify";
import AttendanceList from "./Lists/AttendanceList";
import BankList from "./Lists/BankList";
import SalaryList from "./Lists/SalaryList";
import LeaveBalancePolicyList from "./Lists/LeaveBalancePolicyList";
import PenaltyOvertime from "./Lists/PenaltyOvertime";
import Dropdown from "react-bootstrap/Dropdown";
import debounce from "lodash/debounce";
import { FiDownload } from "react-icons/fi";
import { PiPencilSimpleLineBold } from "react-icons/pi";
import { MdClear } from 'react-icons/md';
import CustomPagination from "../../components/CustomPagination";
import Widgets from "../../components/Widgets";
import FormControl from "@mui/material/FormControl";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { Row, Col, Form, InputGroup } from "react-bootstrap";
import Switch from "@mui/material/Switch";
import TableSkeleton from "../../components/table/TableSkeleton.js";

import {
  downloadCSV,
  getEmployeeFormattedData,
  getCurrentDate,
  getInitials,
  getInitialColor,
} from "../../services/commonServices";
import Salarybox_Bulk_Add_Employee_Template from "../../assets/files/mutiple_staff_data.xlsx";
import { useDispatch, useSelector } from "react-redux";

import { createEmployee, initEmpState } from "../../redux/slices/employeeSlice";

import {
  fetchDepartmentData,
  initDepartState,
} from "../../redux/slices/departmentSlice";

import {
  fetchDesignationList,
  initDesigState,
} from "../../redux/slices/designationSlice";

import {
  commonSaveData,
  commonGetData,
  commonGetDataOne,
  commonGetDataTwo,
  commonGetDataThird,
  commonGetDataFourth,
  initState,
  initCommonState,
} from "../../redux/slices/commonSlice";
import {
  fetchBranchData,
  initBranchState,
} from "../../redux/slices/branchSlice";

import { fetchData as fetchShiftList, initShiftState } from "../../redux/slices/shiftsSlice.js";

import {
  getEmployeeDataOne,
  getEmployeeDataTwo,
  getEmployeeDataThree,
  initRmLevel1State,
  initRmLevel2State,
  initRmLevel3State
} from "../../redux/slices/employeeSlice";

import { employeeAttType, initAttTypeState } from "../../redux/slices/attendanceSlice.js";
import { fetchHolidayData, initFetchHolidayState } from "../../redux/slices/holidaySlice.js";
import { initFetchLeaveState, fetchLeaveData } from "../../redux/slices/leaveSlice.js";
import {
  checkUserRecordsPath,
  getEmployeeStaffListPath,
  multipleStaffPath,
  getEmployerIdListPath,
  deactivateEmployeePath,
  getMyBreaksListPath,
  getRMTeamLeaderListPath,
  getRMManagerListPath,
  getRMHeadListPath,
  getAttendanceModulePath,
  getEmployeeManageListPath,
  getHolidayMainPath,
  getLeaveMain
} from "../../services/config";

// User permissions
import { HasPermission } from "../../services/hasPermission";
import { HasHeaderPermission } from "../../services/hasHeaderPermission";
import StaffDetails from "./Lists/StaffDetails.js";

const animatedComponents = makeAnimated();
const EmployeeManagement = () => {
  return <EmployeeManagementTab />;
};

const tabList = [
  {
    tab: "Staff Details",
    hasPermission: HasPermission("Staff Details", "view"),
  },
  {
    tab: "Attendance Details",
    hasPermission: HasPermission("Attendance Details", "view"),
  },
  { tab: "Bank Details", hasPermission: HasPermission("Bank Details", "view") },
  {
    tab: "Salary Details",
    hasPermission: HasPermission("Salary Details", "view"),
  },
  {
    tab: "Leave Balances & Policy",
    hasPermission: HasPermission("Leave Balances & Policy", "view"),
  },
  { tab: "Permission", hasPermission: HasPermission("Permission", "view") },
];

//  "Penalty & Overtime ", 
const tabStyle = { borderBottom: "4px solid #566573", color: "#566573" };

const EmployeeManagementTab = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch();
  const state = useSelector((state) => state.common);
  const branchState = useSelector((state) => state.branch);
  const employeeState = useSelector((state) => state.employee);
  const designationStore = useSelector((state) => state.designation);
  const departmentState = useSelector((state) => state.department);
  const shiftStore = useSelector((state) => state.shift);
  const employeeStore = useSelector((state) => state.employee);
  const attendanceStore = useSelector((state) => state.attendance)
  const holidayStore = useSelector((state) => state.holiday)
  const leaveStore = useSelector((state) => state.leave)

  const [open, setOpen] = useState(false);
  const user = JSON.parse(localStorage.getItem("user_data")) || {}
  const [highlightTap, setHighlightTap] = useState(0);
  const [branchList, setBranchList] = useState([]);
  const [staffBranchList, setStaffBranchList] = useState([]);
  const [designationList, setDesignationList] = useState([]);
  const [departmentList, setDepartmentList] = useState([]);
  const [employerList, setEmployerList] = useState([]);
  const [shiftList, setShiftList] = useState([]);
  const [breakList, setBreakList] = useState([]);
  const [rmLevel1List, setRmLevel1List] = useState([]);
  const [rmLevel2List, setRmLevel2List] = useState([]);
  const [rmLevel3List, setRmLevel3List] = useState([]);
  const [attendanceType, setAttendanceType] = useState([]);
  const [holidayList, setHolidayList] = useState([]);
  const [leaveList, setLeaveList] = useState([]);

  const [validated, setValidated] = useState(false);
  const [validatedStaff, setValidatedStaff] = useState(false);

  const [multiStaff, setMultiStaff] = useState({
    branch: null,
    userId: user.user_id,
    staffDetails: [],
  });

  const [userRecord, setUserRecord] = useState({});

  const [isAddStaff, setIsAddStaff] = useState(false);

  const [saveBranch, setSaveBranch] = useState({
    modules: [],
  });

  const [multiBreak, setMultiBreak] = useState({
    modules: [],
  });

  const [checked, setChecked] = useState(false);
  const [moduleError, setModuleError] = useState(false);
  const [breakModuleError, setBreakModuleError] = useState(false);

  const [addStaff, setAddStaff] = useState({
    userId: user?.user_id,
    name: "",
    jobTitle: "",
    branch: "",
    department: "",
    shiftId: "",
    breakId: "",
    attendanceId: "",
    rmLevel1: "",
    rmLevel2: "",
    rmLevel3: "",
    holidayId: "",
    leaveId: "",
    code: "+91",
    number: "",
    loginOtp: "",
    empId: "",
    gender: "",
    personalEmailId: "",
    officeEmailId: "",
    dateOfJoining: "",
    address: "",
    isEnableManualEmpId: "",
    empCustomNumber: "",
    designationId: "",
  });

  const inputsOne = [
    {
      type: "text",
      name: "name",
      label: "Name",
      placeholder: "Enter Name",
      required: true,
    },
    {
      type: "text",
      name: "designationId",
      label: " Job Title",
      placeholder: "Select Job Title",
      isMulti: false,
      chi: designationList,
    },
    {
      type: "text",
      name: "branch",
      label: "Branch",
      placeholder: "Enter Branch",
      required: true,
      isMulti: true,
      chi: staffBranchList,
    },
    {
      type: "text",
      name: "department",
      label: "Department",
      placeholder: "Select  Department",
      isMulti: false,
      chi: departmentList,
    },

    {
      type: "select",
      name: "shiftId",
      label: "Shift",
      placeholder: "Select  Shift",
      required: true,
      isMulti: false,
      chi: shiftList,
    },

    {
      type: "select",
      name: "breakId",
      label: "Break",
      placeholder: "Select  Break",
      required: true,
      isMulti: true,
      chi: breakList,
    },

    {
      type: "select",
      name: "attendanceId",
      label: "Attendance Type",
      placeholder: "Select  Attendance Type",
      required: true,
      isMulti: false,
      chi: attendanceType,
    },

    {
      type: "select",
      name: "rmLevel1",
      label: "RM Level 1",
      placeholder: "Select  Manager",
      required: false,
      isMulti: false,
      chi: rmLevel1List,
      onclick: true,
      level: 1
    },

    {
      type: "select",
      name: "rmLevel2",
      label: "RM Level 2",
      placeholder: "Select  Manager",
      required: false,
      isMulti: false,
      chi: rmLevel2List,
      onclick: true,
      level: 2
    },

    {
      type: "select",
      name: "rmLevel3",
      label: "RM Level 3",
      placeholder: "Select  Manager",
      required: false,
      isMulti: false,
      chi: rmLevel3List,
      onclick: true,
      level: 3
    },

    {
      type: "select",
      name: "holidayId",
      label: "Select Holiday",
      placeholder: "Select Holiday",
      required: true,
      isMulti: false,
      chi: holidayList
    },
    {
      type: "select",
      name: "leaveId",
      label: "Select leave",
      placeholder: "Select leave",
      required: true,
      isMulti: false,
      chi: leaveList
    },
  ];

  const inputsTwo = [
    {
      type: "email",
      name: "personalEmailId",
      required: true,
      label: "Personal Email Id",
      placeholder: "Enter Personal Email Id",
    },
    {
      type: "text",
      name: "empId",
      required: true,
      label: "Employee Id",
      chi: employerList,
    },
  ];

  // ✅ Strip any hash from URL on mount + set first permitted tab
  useEffect(() => {
    // Remove hash from URL without reload
    if (window.location.hash) {
      window.history.replaceState(null, "", window.location.pathname);
    }
    const firstPermittedTab = tabList.find((item) => item.hasPermission);
    if (firstPermittedTab) {
      const index = tabList.indexOf(firstPermittedTab);
      setHighlightTap(index);
    }
  }, []);

  const handleHighlightTap = (val) => {
    setHighlightTap(val);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const getBranchList = useCallback(() => {
    dispatch(fetchBranchData(user.user_id));
    dispatch(commonGetDataThird(`${checkUserRecordsPath}${user.user_id}`));

    dispatch(fetchDepartmentData(user.user_id));
    dispatch(commonGetDataFourth(`${getEmployerIdListPath}${user.user_id}`));
    dispatch(fetchDesignationList(user.user_id));
    dispatch(fetchShiftList(user.user_id))
    dispatch(commonGetDataOne(`${getMyBreaksListPath}${user?.user_id}`));

    // dispatch(getEmployeeDataOne(getRMTeamLeaderListPath("", user.user_id)))
    // dispatch(getEmployeeDataTwo(getRMManagerListPath("", user.user_id)))
    // dispatch(getEmployeeDataThree(getRMHeadListPath("", user.user_id)))

    dispatch(employeeAttType(`${getAttendanceModulePath}${user.user_id}`))
    dispatch(fetchHolidayData(`${getHolidayMainPath}${user.user_id}`))
    dispatch(fetchLeaveData(`${getLeaveMain}${user.user_id}`))
  }, []);

  const getRmLevelList = (level) => {
    let staffId = level == 1 ?
      addStaff.rmLevel1 == "" && addStaff.rmLevel2 == "" && addStaff.rmLevel3 == "" ? "0"
        : `${addStaff.rmLevel2},${addStaff.rmLevel3}`
      : level == 2 ? addStaff.rmLevel1 == "" && addStaff.rmLevel2 == "" && addStaff.rmLevel3 == "" ? "0"
        : `${addStaff.rmLevel1},${addStaff.rmLevel3}`
        : addStaff.rmLevel1 == "" && addStaff.rmLevel2 == "" && addStaff.rmLevel3 == "" ? "0"
          : `${addStaff.rmLevel1},${addStaff.rmLevel2}`

    let pathName = `${getEmployeeManageListPath}${user.user_id}&individualStaffId=${staffId}`
    if (level == 1) {
      dispatch(getEmployeeDataOne(pathName));
    } else if (level == 2) {
      dispatch(getEmployeeDataTwo(pathName));
    } else {
      dispatch(getEmployeeDataThree(pathName));
    }
  }

  useEffect(() => {

  }, []);

  useEffect(() => {

    if (state.commonGetSuccess) {
      getBranchList();
    }

    if (branchState.brnGetSuccess) {
      if (branchState.brnGetData) {
        setBranchList(branchState.brnGetData);
        const newArr = branchState.brnGetData.map((v) => {
          return { label: v.branch_name, value: v.branchId };
        });
        setStaffBranchList(newArr);
      }
      dispatch(initBranchState());
    }

    if (state.commonGetOneSuccess) {
      const newArr = state.commonGetOneData.map((v) => {
        return { label: v.break_name, value: v.breakId };
      });
      setBreakList(newArr)
      dispatch(initState());
      dispatch(initCommonState())
    }

    if (state.commonGetThirdSuccess) {
      if (state.commonGetThirdData) {
        setUserRecord(state.commonGetThirdData);
      }

      dispatch(initState());
    }

    if (departmentState.depGetSuccess) {
      if (departmentState.depGetData) {
        const newArr = departmentState.depGetData.map((v) => {
          return { label: v.department_name, value: v.departmentId };
        });
        setDepartmentList(newArr);
      }

      dispatch(initDepartState());
    }

    if (designationStore.desigSuccess) {
      if (designationStore.desigData) {
        const newArr = designationStore.desigData?.map((v) => {
          return { label: v.designation_name, value: v.designationId };
        });

        setDesignationList(newArr);
      }

      dispatch(initDesigState());
    }

    if (state.commonGetFourthSuccess) {
      if (state.commonGetFourthData?.length < 1) {
        toast.error("Please Create an Employer id first to add staff here.");
        return;
      }
      setEmployerList(state.commonGetFourthData);

      dispatch(initCommonState());
    }

    if (employeeState.empSuccess) {
      toast.success(employeeState.empMessage);
      dispatch(initEmpState());
      setAddStaff({
        name: "",
        jobTitle: "",
        branch: "",
        department: "",
        shiftId: "",
        breakId: "",
        attendanceId: "",
        rmLevel1: "",
        rmLevel2: "",
        rmLevel3: "",
        holidayId: "",
        leaveId: "",
        code: "+91",
        number: "",
        loginOtp: "",
        empId: "",
        gender: "",
        personalEmailId: "",
        officeEmailId: "",
        dateOfJoining: "",
        address: "",
        empCustomNumber: "",
      });
      setChecked(false);
      setSaveBranch({
        ...saveBranch,
        modules: [],
      });
      setMultiBreak({
        ...multiBreak,
        modules: [],
      });

      handleAddStaffClose();
    }

    if (employeeState.empError) {
      toast.error(employeeState.empMessage);
      dispatch(initEmpState());
    }

    if (shiftStore.shiftGetSuccess) {
      if (shiftStore.shiftGetData) {
        const newArr = shiftStore.shiftGetData?.map((v) => {
          return { label: v.shiftName, value: v.shiftId };
        }) || [];
        setShiftList(newArr)
        dispatch(initShiftState())
      }
    }

    if (employeeStore.empGetSuccessOne) {
      const newArr = employeeStore.empGetDataOne?.map((v) => {
        return { label: v.full_name, value: v.staffId };
      }) || [];
      setRmLevel1List(newArr)
      dispatch(initRmLevel1State())
    }

    if (employeeStore.empGetSuccessTwo) {
      const newArr = employeeStore.empGetDataTwo?.map((v) => {
        return { label: v.full_name, value: v.staffId };
      }) || [];
      setRmLevel2List(newArr)
      dispatch(initRmLevel2State())
    }

    if (employeeStore.empGetSuccessThree) {
      const newArr = employeeStore.empGetDataThree?.map((v) => {
        return { label: v.full_name, value: v.staffId };
      }) || [];
      setRmLevel3List(newArr)
      dispatch(initRmLevel3State())
    }

    if (attendanceStore.attTypeSuccess) {
      const newArr = attendanceStore.attTypeData?.data?.map((v) => {
        return { label: v.moduleName, value: v.attendanceId };
      }) || [];
      setAttendanceType(newArr)
    }

    if (holidayStore.fetchHolySuccess) {
      const newArr = holidayStore.fetchHolyData?.map((v) => {
        return { label: v.moduleName, value: v.moduleId };
      }) || [];
      setHolidayList(newArr)
      dispatch(initFetchHolidayState())
    }

    if (leaveStore.fetchLeaveSuccess) {
      const newArr = leaveStore.fetchLeaveData?.map((v) => {
        return { label: v.moduleName, value: v.moduleId };
      }) || [];
      setLeaveList(newArr)
      dispatch(initFetchLeaveState())
    }
  }, [
    branchState,
    state,
    designationStore,
    departmentState,
    employeeState,
    shiftStore,
    employeeStore,
    attendanceStore,
    holidayStore,
    leaveStore
  ]);

  const downloadFile = () => {
    const link = document.createElement("a");
    link.href = Salarybox_Bulk_Add_Employee_Template;
    link.download = "mutiple_staff_data.xlsx";
    link.click();
  };

  const handleBranch = (e) => {
    const { value } = e.target;
    setMultiStaff({
      ...multiStaff,
      branch: parseInt(value),
    });
  };

  const handleXlsxRead = (data) => {
    setMultiStaff({
      ...multiStaff,
      staffDetails: data,
    });
  };

  const handleSubmit = (event) => {
    const form = event.currentTarget;
    event.preventDefault();
    event.stopPropagation();
    if (form.checkValidity() === false) {
      setValidated(true);
    } else {
      let d = {
        path: multipleStaffPath,
        data: multiStaff,
      };

      dispatch(commonSaveData(d));
    }
  };

  useEffect(() => {
    if (state.commonSuccess) {
      toast.success(state.commonMessage);
      setMultiStaff({
        ...multiStaff,
        branch: "",
        staffDetails: [],
      });
      handleClose();
      dispatch(commonGetDataTwo(`${checkUserRecordsPath}${user.user_id}`));
    }
    if (state.commonError) {
      toast.error(state.commonMessage);
      handleClose();
    }
  }, [state.commonSuccess, state.commonError]);

  useEffect(() => {
    if (state.commonGetTwoSuccess) {
      setUserRecord(state.commonGetTwoData);
      dispatch(initState());
    }
  }, [branchState.brnGetSuccess, state.commonGetTwoSuccess]);

  const handleUserRecord = (type) => {
    if (
      userRecord.isBranchRecord &&
      userRecord.isDepartmentRecord &&
      userRecord.isEmployerId &&
      userRecord.isShift
    ) {
      if (type == "home") {
        handleClickOpen();
      } else {
        // document.getElementById(type).click();
        setIsAddStaff(true);
      }
    } else {
      toast.error(
        `Please add ${(userRecord.isBranchRecord ? "" : "Branch",
          userRecord.isDepartmentRecord ? "" : "Department",
          userRecord.isEmployerId ? "" : "EmployerId",
          userRecord.isShift ? "" : "Shift")
        } data first`
      );
    }
  };

  const preSubmitBsDtl = () => {
    let elem = document.querySelector("#preSubmitBsDtl");
    if (elem) {
      elem.click();
    }
  };

  const handleAddStaffClose = () => {
    setIsAddStaff(false);
  };

  const handleBranchChange = (e) => {
    setSaveBranch({
      ...saveBranch,
      modules: e,
    });
    setModuleError(false);
  };

  const handleBreakChange = (e) => {
    setMultiBreak({
      ...multiBreak,
      modules: e,
    });
    setBreakModuleError(false);
  };

  const handleCustomChange = (e) => {
    const value = e.target.value;
    if (/^\d*$/.test(value)) {
      setAddStaff({
        ...addStaff,
        empCustomNumber: value,
      });
    }
  };

  const handleChange = (event) => {
    setChecked(event.target.checked);
    setAddStaff({
      ...addStaff,
      isEnableManualEmpId: event.target.checked ? 1 : 0,
    });
    if (event.target.checked == false) {
      setAddStaff({
        ...addStaff,
        empCustomNumber: "",
      });
    }
  };

  const checkLengthHandle = (e) => {
    const { name, value } = e.target;
    if (value === "" || (/^[0-9\b]+$/.test(value) && value.length <= 8)) {
      setAddStaff({ ...addStaff, [name]: value });
    }
  };

  const handleKeyPress = (e) => {
    const { name, value } = e.target;
    if (e.key == "Backspace") {
      setAddStaff({ ...addStaff, [name]: value });
    } else if (!/[0-9]/.test(e.key)) {
      e.preventDefault();
    }
  };

  const handelChange = (e) => {
    const { name, value } = e.target;
    setAddStaff((pv) => ({ ...pv, [name]: value }));
  };

  const preSubmitAddStaff = () => {
    let elem = document.querySelector("#addStaffId");
    if (elem) {
      elem.click();
    }
  };

  const handleAddStaffSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      setValidatedStaff(true);
      if (saveBranch.modules.length < 1) {
        setModuleError(true);
      }

      if (multiBreak.modules.length < 1) {
        setBreakModuleError(true);
      }
    } else {
      let data = {
        userId: user?.user_id,
        cmp_name: user?.company_name,
        fullname: addStaff.name,
        designationId: addStaff.designationId,
        branch: saveBranch.modules.map((v) => v.value).toString(),
        department: addStaff.department,
        shiftId: addStaff.shiftId,
        breakId: multiBreak.modules.map((v) => v.value).toString(),
        attendanceId: addStaff.attendanceId,
        rmLevel1: addStaff.rmLevel1,
        rmLevel2: addStaff.rmLevel2,
        rmLevel3: addStaff.rmLevel3,
        holidayId: addStaff.holidayId,
        leaveId: addStaff.leaveId,
        emp_mobile: addStaff.number,
        pwd: addStaff.loginOtp,
        empId: addStaff.empId,
        gender: addStaff.gender,
        personalEmailId: addStaff.personalEmailId,
        office_email: addStaff.personalEmailId,
        dateof_join: addStaff.dateOfJoining,
        address: addStaff.address,
        isEnableManualEmpId: addStaff.isEnableManualEmpId,
        empCustomNumber: addStaff.empCustomNumber,
      };
      dispatch(createEmployee(data));
    }
  };

  return (
    <>

      <Dialog
        fullWidth={true}
        maxWidth={"sm"}
        open={open}
        onClose={handleClose}
      >
        <DialogTitle className="dialog-title">
          <div className="dialog-title-icon">
            <span className="close-icon" onClick={handleClose}>
              X
            </span>
            <span className="title">Add Multiple Staff</span>
          </div>
          <button
            className="universal-btn border-radius-8px"
            onClick={preSubmitBsDtl}
            style={{ height: "30px", lineHeight: "5px", fontSize: "16px" }}
          >
            Save Changes
          </button>
        </DialogTitle>

        <DialogContent>
          <Form
            noValidate
            validated={validated}
            onSubmit={handleSubmit}
            encType="multipart/form-data"
          >
            <div
              className="mb-3 mt-3"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <p className="color-white">Step 1. Select Branch to add staff</p>
              <Form.Select
                style={{ width: "45%" }}
                required
                onChange={handleBranch}
                className="universal-input-one"
              >
                <option value="">Select branch</option>
                {branchList?.map((r, i) => {
                  return (
                    <option value={r.branchId} key={i}>
                      {r.branch_name}
                    </option>
                  );
                })}
              </Form.Select>
            </div>

            <div
              className="mb-3"
              style={{
                position: "relative",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <p className="color-white">
                Step 2. Download staff details template
              </p>
              <Form.Control
                placeholder="Download Template"
                readOnly
                onClick={downloadFile}
                style={{ width: "45%" }}
                className="universal-input-one"
              />
              {multiStaff.branch && (
                <FaDownload
                  onClick={downloadFile}
                  style={{
                    position: "absolute",
                    right: "10px",
                    color: "lime",
                    fontWeight: "bold",
                    fontSize: "20px",
                    cursor: "pointer",
                  }}
                />
              )}
            </div>

            <div
              className="mb-3"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <p className="color-white">
                Step 3. Edit Downloaded file and add staff details template
                <br />
                <span style={{ fontSize: "12px" }} className="color-white">
                  Please refer to instructions sheet in download template for
                  formatting guide
                </span>
              </p>
            </div>

            <div
              className="mb-3"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <p className="color-white">Step 4. Upload your staff list</p>
              <div style={{ width: "45%" }}>
                <ExcelReader
                  onChange={handleXlsxRead}
                  className="universal-input-one"
                />
              </div>
            </div>
            <Button
              variant="contained"
              color="info"
              type="submit"
              style={{ display: "none" }}
              id="preSubmitBsDtl"
            >
              Save
            </Button>
          </Form>
        </DialogContent>
      </Dialog>

      <Dialog
        fullWidth={true}
        maxWidth={"sm"}
        open={isAddStaff}
        onClose={handleAddStaffClose}
      >
        <DialogTitle className="dialog-title">
          <div className="dialog-title-icon">
            <span className="close-icon" onClick={handleAddStaffClose}>
              X
            </span>
            <span className="title">Add New Employee</span>
          </div>
          <button
            className="universal-btn border-radius-8px"
            onClick={preSubmitAddStaff}
            style={{ height: "30px" }}
          >
            Add
          </button>
        </DialogTitle>

        <DialogContent>
          <Form
            noValidate
            validated={validatedStaff}
            onSubmit={handleAddStaffSubmit}
            style={{ paddingBottom: "20px" }}
          >
            <Row>
              {inputsOne.map((item, i) => (
                <Col sm="6" className="mt-3" key={i}>
                  <Form.Group>
                    <Form.Label className="color-white">
                      {item.label}
                      <span style={{ color: "red" }}>
                        {item.required ? "*" : ""}
                      </span>
                    </Form.Label>
                    {/* handleBreakChange */}
                    {item.isMulti && item.chi ? item.name == "branch" ?
                      <>
                        <FormControl
                          style={{
                            width: "100%",
                            border: moduleError && "1px solid red",
                            borderRadius: "7px",
                          }}
                        >
                          <Select
                            closeMenuOnSelect={false}
                            components={animatedComponents}
                            value={saveBranch.modules}
                            name={item.name}
                            isMulti
                            placeholder="Select branch"
                            options={item.chi}
                            onChange={handleBranchChange}
                            // className="universal-input"
                            styles={customStyles}
                          />
                        </FormControl>
                        {moduleError && (
                          <label style={{ color: "red", fontSize: "14px" }}>
                            Please select a valid branch
                          </label>
                        )}
                      </> : <>
                        <FormControl
                          style={{
                            width: "100%",
                            border: moduleError && "1px solid red",
                            borderRadius: "7px",
                          }}
                        >
                          <Select
                            closeMenuOnSelect={false}
                            components={animatedComponents}
                            value={multiBreak.modules}
                            name={item.name}
                            isMulti
                            placeholder="Select Break"
                            options={item.chi}
                            onChange={handleBreakChange}
                            // className="universal-input"
                            styles={customStyles}
                          />
                        </FormControl>
                        {breakModuleError && (
                          <label style={{ color: "red", fontSize: "14px" }}>
                            Please select a valid break
                          </label>
                        )}
                      </>
                      : !item.isMulti && item.chi ? (
                        <Form.Select
                          style={{ width: "100%", color: "gray" }}
                          name={item.name}
                          onChange={handelChange}
                          value={addStaff[item.name]}
                          className="universal-input"
                          onClick={(e) => item.onclick ? getRmLevelList(item.level, e) : ""}
                        >
                          <option value="">{item.placeholder}</option>
                          {item.chi.map((v, id) => {
                            return (
                              <option value={v.value} key={id}>
                                {v.label}
                              </option>
                            );
                          })}
                          {item.chi.length < 1 && (
                            <option value="">
                              <Link to=""> Add Department </Link>
                            </option>
                          )}
                        </Form.Select>
                      ) : (
                        <Form.Control
                          name={item.name}
                          type={item.type || ""}
                          placeholder={item.placeholder}
                          value={addStaff[item.name]}
                          onChange={handelChange}
                          required={item.required ? true : false}
                          style={{ marginBottom: "10px" }}
                          className="universal-input"
                        />
                      )}
                    <Form.Control.Feedback type="invalid">
                      Please provide a valid {item.label}.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              ))}

              <Col sm="6" className="mt-3">
                <Form.Group>
                  <Form.Label className="color-white">
                    Mobile Number <span style={{ color: "red" }}>*</span>
                  </Form.Label>
                  <InputGroup>
                    <InputGroup.Text
                      id="basic-addon1"
                      style={{
                        height: " 40px",
                        backgroundColor: " #ffffff04",
                        color: " #a5a4a4",
                        border: " 1px solid gray",
                        borderTopLeftRadius: "12px",
                        borderBottomLeftRadius: "12px",
                      }}
                    >
                      +91
                    </InputGroup.Text>
                    <Form.Control
                      type="text"
                      name="number"
                      pattern="\d*"
                      maxlength="10"
                      placeholder={"Enter Mobile Number"}
                      aria-label="number"
                      aria-describedby="basic-addon1"
                      required
                      value={addStaff.number}
                      onChange={handelChange}
                      onKeyDown={() => {
                        checkLengthHandle, handleKeyPress;
                      }}
                      style={{
                        border: " 1px solid gray",
                        borderTopRightRadius: "12px",
                        borderBottomRightRadius: "12px",
                        zIndex: 0,
                        height: " 40px",
                        backgroundColor: " #ffffff04",
                      }}
                      className="placeholder-color-gray color-white"
                    />
                    <Form.Control.Feedback type="invalid">
                      Please provide a valid mobile number.
                    </Form.Control.Feedback>
                  </InputGroup>
                </Form.Group>
              </Col>

              {inputsTwo.map((item, i) =>
                item.chi ? (
                  <Col sm="6" className="mt-3" key={i}>
                    <Form.Group>
                      <Form.Label className="color-white">
                        {item.label}
                        <span style={{ color: "red" }}>
                          {item.required ? "*" : ""}
                        </span>
                      </Form.Label>
                      <Form.Select
                        required
                        name={item.name}
                        onChange={handelChange}
                        value={addStaff[item.name]}
                        style={{ color: "gray" }}
                        className="universal-input"
                      >
                        <option value="">Select Employee ID Prefix</option>
                        {item.chi.map((dv, i) => (
                          <option key={i} value={dv.employerId}>
                            {dv.employerIdName}
                          </option>
                        ))}
                      </Form.Select>
                      <Form.Control.Feedback type="invalid">
                        Please select a valid option.
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                ) : (
                  <Col
                    sm={item.type == "date" ? "12" : "6"}
                    key={i}
                    className="mt-3"
                  >
                    <Form.Group>
                      <Form.Label className="color-white">
                        {item.label}
                        <span style={{ color: "red" }}>
                          {item.required ? "*" : ""}
                        </span>
                      </Form.Label>

                      <Form.Control
                        name={item.name}
                        type={item.type || ""}
                        value={addStaff[item.name]}
                        placeholder={item.placeholder}
                        onChange={handelChange}
                        required={item.required ? true : false}
                        className="universal-input"
                      />

                      <Form.Control.Feedback type="invalid">
                        Please provide a valid {item.label}.
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                )
              )}
              <Col sm="6" style={{ position: "relative", top: "33px" }}>
                <Form.Group>
                  <Form.Label className="color-white">
                    Manual Assignment Enabled
                  </Form.Label>
                  <Switch
                    name="isEnableManualEmpId"
                    checked={checked}
                    onChange={handleChange}
                    inputProps={{ "aria-label": "controlled" }}
                  />
                  <br />
                  <span
                    style={{
                      position: "relative",
                      fontSize: "12px",
                      top: "-8px",
                      color: "gray",
                    }}
                  >
                    {!checked &&
                      "Allocate ID number Manually (Disabling this the system will auto allocate the number in sequence) "}
                  </span>
                </Form.Group>
              </Col>
            </Row>
            {checked && (
              <Row className="mt-4">
                <Col sm="12">
                  <Form.Group>
                    <Form.Label className="color-white">
                      Employee Custom Number:{" "}
                    </Form.Label>
                    <Form.Control
                      name="empCustomNumber"
                      value={addStaff.empCustomNumber}
                      onChange={handleCustomChange}
                      placeholder="Employee Custom Number"
                      className="universal-input"
                    />
                    <span
                      style={{
                        position: "relative",
                        fontSize: "12px",
                        // top: "-8px",
                        color: "gray",
                      }}
                    >
                      Enter the required number in this format (sequence
                      selected in the backend when adding the Employee ID Prefix
                      basis on the selection of employee ID prefix)
                    </span>
                  </Form.Group>
                </Col>
              </Row>
            )}

            {HasPermission("Employee", "create") && (
              <div className="submit-btn">
                <button
                  type="submit"
                  disabled={employeeState.empLoading ? true : false}
                  className="universal-btn"
                  id="addStaffId"
                  style={{ display: "none" }}
                >
                  {" "}
                  {employeeState.empLoading ? "Saving..." : "Save"}
                </button>
              </div>
            )}
          </Form>
        </DialogContent>
      </Dialog>

      <div className="EmployeeManagement">
        <div className="EmployeeManagement-card-two">
          <div className="EmpTab universal-bg-color">
            {tabList.map((item, i) => {
              return item.hasPermission ? (
                <p
                  style={highlightTap === i ? tabStyle : null}
                  onClick={() => { handleHighlightTap(i); }}
                  key={i}
                  className="pointer"
                >
                  {item.tab}
                </p>
              ) : null;
            })}
          </div>

          {HasPermission("Staff Details", "create") && (
            <Dropdown className="add-staff-bg">
              <Dropdown.Toggle
                style={{
                  border: "none",
                }}
                className="universal-btn"
                id="dropdown-basic"
              >
                Add Staff
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item
                  onClick={() => {
                    handleUserRecord("goToAddStaff");
                  }}
                >
                  Add Staff
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={() => {
                    handleUserRecord("home");
                  }}
                >
                  Add Multiple staff
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          )}

          <Link to={"add-staff"} id="goToAddStaff" style={{ display: "none" }}>
            Add Staff
          </Link>
        </div>

        <div className="EmployeeManagement-card-three">
          {highlightTap == 0 && HasPermission("Staff Details", "view") && (
            // <Categories
            <StaffDetails
              dispatch={dispatch}
              user={user}
              state={state}
              employeeState={employeeState}
              branchList={branchList}
              designationList={designationList}
              departmentList={departmentList}
            />
          )}
          {highlightTap == 1 && HasPermission("Attendance Details", "view") && (
            <AttendanceList
              dispatch={dispatch}
              user={user}
              state={state}
              branchList={branchList}
              designationList={designationList}
              departmentList={departmentList}
            />
          )}
          {highlightTap == 2 && HasPermission("Bank Details", "view") && (
            <BankList
              dispatch={dispatch}
              user={user}
              state={state}
              branchList={branchList}
              designationList={designationList}
              departmentList={departmentList}
            />
          )}
          {highlightTap == 3 && HasPermission("Salary Details", "view") && (
            <SalaryList
              dispatch={dispatch}
              user={user}
              state={state}
              branchList={branchList}
              designationList={designationList}
              departmentList={departmentList}
            />
          )}
          {highlightTap == 4 &&
            HasPermission("Leave Balances & Policy", "view") && (
              <LeaveBalancePolicyList
                dispatch={dispatch}
                user={user}
                state={state}
                branchList={branchList}
                designationList={designationList}
                departmentList={departmentList}
              />
            )}
          {highlightTap == 5 && HasPermission("Permission", "view") && (
            <PenaltyOvertime
              dispatch={dispatch}
              user={user}
              state={state}
              branchList={branchList}
              designationList={designationList}
              departmentList={departmentList}
            />
          )}
        </div>
        <div className="EmployeeManagement-card-fore"></div>
      </div>

      <ToastContainer
        position="top-right"
        autoClose={2000}
        className="toast-custom"
      />
    </>
  );
};

const Categories = ({
  dispatch,
  user,
  state,
  employeeState,
  branchList,
  designationList,
  departmentList,
}) => {
  const [usersList, setUsersList] = useState([]);
  const [filteredUsersList, setFilteredUsersList] = useState([]);
  const [filterUser, setFilterUser] = useState("");

  const [jobTitle, setJobTitle] = useState("");
  const [departmentId, setDepartmentId] = useState(0);
  const [branch, setBranch] = useState(0);

  const [gridApi, setGridApi] = useState(null);

  const onGridReady = (params) => {
    setGridApi(params.api);
  };

  const path = `${getEmployeeStaffListPath}${user.user_id}&branchId=${branch}&departmentId=${departmentId}&jobTitle=${jobTitle}`;

  const getEmployeeList = () => {
    setUsersList([]);
    setFilteredUsersList([]);
    dispatch(commonGetData(path));
  };

  useEffect(() => {
    getEmployeeList();
  }, [jobTitle, departmentId, branch, departmentId, dispatch, path]);

  useEffect(() => {
    if (state.commonGetSuccess) {
      if (state.commonGetData == undefined || state.commonGetData == "") {
        setUsersList([]);
        setFilteredUsersList([]);
        dispatch(initState());
      } else {
        if (filterUser) {
          handleSearch(filterUser, state.commonGetData);
        } else {
          setUsersList(state.commonGetData);
          setFilteredUsersList(state.commonGetData);
          dispatch(initState());
        }
      }
    }

    if (state.commonGetError) {
      setUsersList([]);
      setFilteredUsersList([]);
      dispatch(initState());
    }

    if (employeeState.empSuccess) {
      dispatch(commonGetData(path));
    }

    if (state.commonSuccess) {
      toast.success(state.commonMessage)
      getEmployeeList();
      dispatch(initCommonState());
    }

    if (state.commonError) {
      toast.error(state.commonMessage)
      dispatch(initCommonState());
    }
  }, [state, employeeState]);

  const handleSearch = useCallback(
    debounce((query, dataList) => {
      const debouncedQuery = query.trim().toLowerCase();
      const results = dataList.filter(
        (employee) =>
          (employee.employee_id &&
            employee.employee_id.toLowerCase().includes(debouncedQuery)) ||
          (employee.full_name &&
            employee.full_name.toLowerCase().includes(debouncedQuery)) ||
          (employee.mobile_number &&
            employee.mobile_number.includes(debouncedQuery))
      );
      setFilteredUsersList(results);
      setUsersList(dataList);
    }, 500),
    [usersList]
  );

  const searchUser = (event) => {
    const {
      target: { value },
    } = event;
    setFilterUser(value);
    handleSearch(value, usersList);
  };

  const downloadBulkData = () => {
    downloadCSV(
      getEmployeeFormattedData(filteredUsersList),
      `${getCurrentDate()}_Staff_Detail.csv`
    );
  };

  const columns = [
    {
      headerName: "SNo",
      valueGetter: (params) => params.node.rowIndex + 1,
      width: 60,
      pinned: "left",
    },
    {
      headerName: "Employee ID",
      field: "employee_id",
      width: 120,
      pinned: "left",
    },
    {
      headerName: "Name",
      width: "350px",
      pinned: true,
      cellRenderer: (rowData) => {
        return (
          rowData?.data?.staffId ?
            <Link
              to={`user-info/${rowData?.data?.staffId}`}
              className="table-link d-flex align-items-center justify-content-start gap-2"
            >
              <div
                style={{
                  width: "30px",
                  height: "30px",
                  border: "1px solid lightgray",
                  borderRadius: "50%",
                  overflow: "hidden",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: getInitialColor(rowData.data.full_name),
                  color: "white",
                  fontWeight: "bold",
                  fontSize: "12px",
                }}
              >
                {getInitials(rowData.data.full_name)}
              </div>
              {rowData.data.full_name}
            </Link> : "-"
        );
      },
    },
    {
      headerName: "Job Title",
      field: "job_title",
    },
    {
      headerName: "Date of Join",
      field: "date_of_join",
    },
    {
      headerName: "Date of Leaving",
      field: "date_of_leaving",
    },
    {
      headerName: "Date of Birth",
      field: "dob",
    },
    {
      headerName: "Mobile Number",
      field: "mobile_number",
      width: "100px",
    },
    {
      headerName: "Personal Email",
      field: "personal_email",
      width: "300px",
      cellStyle: {
        display: "flex",
        alignItems: "center",
        whiteSpace: "normal",
        lineHeight: "1.5",
        marginRight: "10px",
      },
      autoHeight: true,
    },
    {
      headerName: "Official Email",
      field: "official_email",
      width: "300px",
      cellStyle: {
        display: "flex",
        alignItems: "center",
        whiteSpace: "normal",
        lineHeight: "1.5",
        marginRight: "10px",
      },
      autoHeight: true,
    },
    {
      headerName: "Marital Status",
      field: "marital_status",
    },
    {
      headerName: "Gender",
      field: "gender",
    },
    {
      headerName: "Blood Group",
      field: "blood_group",
    },
    {
      headerName: "Present Address",
      field: "addressDetails.address",
      autoHeight: true,
      wrapText: true,
      resizable: true,
      cellClass: "custom-wrap-cell",
      width: "300px",
    },
    {
      headerName: "Aadhaar Number",
      field: "governmentIds.aadhar_number",
    },
    {
      headerName: "PAN Number",
      field: "governmentIds.pan_number",
    },
    {
      headerName: "UAN Number",
      field: "governmentIds.uan_number",
    },
    {
      headerName: "PF Number",
      field: "governmentIds.pf_number",
    },
    {
      headerName: "Emergency Contact Name",
      field: "addressDetails.emergencyContactName",
    },
    {
      headerName: "Emergency Contact Mobile",
      field: "addressDetails.emergencyContactNumber",
    },
    {
      headerName: "Emergency Contact Relationship",
      field: "addressDetails.emergencyContactRelation",
    },

    {
      headerName: "Action",
      pinned: "right",
      width: "150px",
      cellRenderer: (rowData) => {
        return (
          <div
            style={{ position: "relative", top: "9px" }}
            className="d-flex align-items-center justify-content-start gap-3"
          >
            <select
              className={
                rowData.data.status == "1" ? "statusGreen" : "statusOrange"
              }
              value={rowData.data.status}
              onChange={(e) => handleActiveInactiveChange(e, rowData.data)}
            >
              <option value="1">Active</option>
              <option value="0">InActive</option>
            </select>
            <Link
              to={`user-info/${rowData.data.staffId}`}
              className="table-link d-flex align-items-center justify-content-start gap-2"
              style={{ fontSize: "24px" }}
            >
              <PiPencilSimpleLineBold className="edit-icon" />
            </Link>
          </div>
        );
      },
    },
  ];

  const handleActiveInactiveChange = (event, rowData) => {
    const data = {
      path: deactivateEmployeePath,
      data: {
        userId: user.user_id,
        staffId: rowData.staffId,
        isActiveUser: event.target.value,
      },
    };
    dispatch(commonSaveData(data));
  };

  const paginationPageSize = 10;

  const clearFilter = () => {
    setUsersList([]);
    setFilteredUsersList([]);
    getEmployeeList()
    setFilterUser("")
    setJobTitle("")
    setDepartmentId(0)
    setBranch(0)
  }

  return (
    <div className="staff-detail">
      <div className="search-box flex-space-between mt-m-40">
        <Form className="d-flex align-items-center justify-content-start gap-2">
          <Form.Group>
            <Form.Control
              placeholder="Search by Employee Name & ID"
              onChange={searchUser}
              name="filterUser"
              value={filterUser}
              className="universal-input-one"
              style={{ width: "250px" }}
            />
          </Form.Group>

          <Form.Group>
            <Form.Select
              onChange={(e) => setJobTitle(e.target.value)}
              name="jobTitle"
              value={jobTitle}
              className="universal-input-one"
              style={{ width: "200px" }}
            >
              <option value={0}>Select Job Title</option>
              {designationList?.map((row) => {
                return <option value={encodeURIComponent(row.label)}>{row.label}</option>;
              })}
            </Form.Select>
          </Form.Group>

          {/* <Form.Group>
            <Form.Select
              onChange={(e) => setJobType(e.target.value)}
              name="jobType"
              value={jobType}
              className="universal-input-one"
            >
              <option>Job Type</option>
            </Form.Select>
          </Form.Group> */}

          <Form.Group>
            <Form.Select
              onChange={(e) => setDepartmentId(e.target.value)}
              name="departmentId"
              value={departmentId}
              className="universal-input-one"
              style={{ width: "200px" }}
            >
              <option value={0}>Select Department</option>
              {departmentList?.map((row) => {
                return <option value={row.value}>{row.label}</option>;
              })}
            </Form.Select>
          </Form.Group>

          <Form.Group>
            <Form.Select
              onChange={(e) => setBranch(e.target.value)}
              name="branch"
              value={branch}
              className="universal-input-one"
              style={{ width: "200px" }}
            >
              <option value={0}>Select Branch</option>
              {branchList?.map((row) => {
                return <option value={row.branchId}>{row.branch_name}</option>;
              })}
            </Form.Select>
          </Form.Group>
          <Form.Group>
            {
              (filterUser ||
                jobTitle ||
                departmentId != 0 ||
                branch != 0) && <button type="button" className="clear" onClick={clearFilter}>
                <MdClear /> Clear
              </button>
            }
          </Form.Group>
        </Form>
      </div>

      <Widgets
        body={
          <>
            <div
              className="ag-theme-quartz custom-grid"
              style={{ height: "calc(100vh - 310px)", width: "100%" }}
            >
              {state.commonGetLoading ? (
                <TableSkeleton />
              ) : (
                <AgGridReact
                  rowData={
                    Array.isArray(filteredUsersList) ? filteredUsersList : []
                  }
                  columnDefs={columns}
                  omLayout="autoHeight"
                  pagination={true}
                  paginationPageSize={paginationPageSize}
                  onGridReady={onGridReady}
                />
              )}
            </div>
            <div className="d-flex align-items-center justify-content-between custom-pagination">
              {gridApi && <CustomPagination gridApi={gridApi} />}

              {HasPermission("Staff Details", "export") && (
                <Button
                  onClick={downloadBulkData}
                  className="bulkDataDownloads universal-btn"
                >

                  <FiDownload
                    style={{ fontSize: "18px", marginRight: "10px" }}
                  />
                  Download Bulk Details
                </Button>
              )}
            </div>
          </>
        }
      />
    </div>
  );
};

const customStyles = {
  menuPortal: (base) => ({
    ...base,
    width: "340px",
    height: "40px",
  }),

  control: (provided) => ({
    ...provided,
    border: "1px solid gray",
    borderRadius: "12px",
    boxShadow: "none",
    backgroundColor: "transparent",
    minHeight: "40px",
  }),

  // ✅ FIXES the | pipe separator
  indicatorSeparator: () => ({
    display: "none",
  }),

  // ✅ FIXES the double border — strips inner input styling
  input: (provided) => ({
    ...provided,
    border: "none",
    boxShadow: "none",
    outline: "none",
    padding: "0",
    margin: "0",
    color: "#fff",
  }),

  // ✅ FIXES placeholder color
  placeholder: (provided) => ({
    ...provided,
    color: "#9998A2",
    fontSize: "12px",
  }),

  // ✅ FIXES selected value color
  singleValue: (provided) => ({
    ...provided,
    color: "#E3E2EB",
  }),

  multiValue: (provided) => ({
    ...provided,
    backgroundColor: "#8660F820",
    borderRadius: "6px",
  }),

  multiValueLabel: (provided) => ({
    ...provided,
    color: "#E3E2EB",
  }),

  multiValueRemove: (provided) => ({
    ...provided,
    color: "#9998A2",
    ":hover": {
      backgroundColor: "#EF444430",
      color: "#EF4444",
    },
  }),

  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused
      ? "gray"
      : state.isSelected
      ? "#90caf9"
      : "#1e1d2e",
    color: "#fff",
    cursor: "pointer",
  }),

  menu: (provided) => ({
    ...provided,
    backgroundColor: "#1e1d2e",
    borderRadius: "12px",
    zIndex: 9999,
  }),

  valueContainer: (provided) => ({
    ...provided,
    padding: "2px 8px",
  }),
};

export default EmployeeManagement;